<template>
  <div class="content">
    <div class="section mt-0">
      <h1 class="title title--h1 title__separate">Blog</h1>
    </div>

    <div v-if="loading" class="section text-center">
      <div class="loading-spinner"></div>
      <p class="loading-text">Loading posts...</p>
    </div>

    <div v-else-if="error" class="section">
      <div class="alert-notice">
        <p>{{ error }}</p>
      </div>
    </div>

    <div v-else>
      <div class="news-grid section">
        <article class="news-item box blog-card" v-for="post in blogPosts" :key="post.slug">
          <div class="news-item__image-wrap overlay overlay--45">
            <div class="news-item__date">
              {{ post.day }} <span>{{ post.month }}</span>
            </div>
            <router-link :to="'/blog/' + post.slug" class="news-item__link"></router-link>
            <img :src="post.image" :alt="post.alt" class="cover">
            <div class="blog-card__read-icon">
              <em class="icon-book-open"></em>
              <span>Read</span>
            </div>
          </div>
          <div class="news-item__caption">
            <h3 class="title title--h4">
              <router-link :to="'/blog/' + post.slug" class="blog-title-link">
                {{ post.title }}
              </router-link>
            </h3>
            <p class="blog-excerpt">{{ post.excerpt }}</p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchBlogPosts } from '@/services/hashnode'
import fallbackPosts from '@/data/blogPosts'

export default {
  name: 'BlogView',
  data() {
    return {
      blogPosts: [],
      loading: true,
      error: null
    }
  },
  async created() {
    try {
      this.blogPosts = await fetchBlogPosts()
      if (this.blogPosts.length === 0) {
        this.blogPosts = fallbackPosts
      }
    } catch {
      this.blogPosts = fallbackPosts
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.blog-title-link {
  color: inherit;
  text-decoration: none;
}
.blog-excerpt {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.loading-spinner {
  width: 40px;
  height: 40px;
  margin: 20px auto;
  border: 3px solid rgba(134, 151, 168, 0.3);
  border-top-color: #0d86ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.loading-text {
  color: #8697a8;
  font-size: 14px;
  margin-top: 8px;
}
.alert-notice {
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.3);
  border-radius: 8px;
  padding: 16px;
  color: #ff6b6b;
  font-size: 14px;
}
.blog-card {
  cursor: pointer;
}
.news-item__image-wrap {
  position: relative;
}
.blog-card__read-icon {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: rgba(0, 0, 0, 0.55);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
  pointer-events: none;
}
.blog-card:hover .blog-card__read-icon {
  opacity: 1;
}
.blog-card__read-icon em {
  font-size: 32px;
  color: #fff;
}
.blog-card__read-icon span {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
</style>
